import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { appReducer } from './../reducers/AppReducer';
import { cidadeReducer } from "./../reducers/CidadesReducer";
import { estadoReducer } from "./../reducers/EstadosReducer";
import thunk from 'redux-thunk';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export const rootReducer = combineReducers({ 
    appReducer,
    cidadeReducer,
    estadoReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export const useTSelector: TypedUseSelectorHook<RootState> = useSelector;

// salva o state do redux para o localStorage
const saveToLocalStore = (state: any) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (e) {
        console.log("Erro ao tentar gravar o state do Redux no localStorage - " + e);
    }
}

// le o state do localStorage para o redux
const loadFromLocalStore = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        console.log("Erro ao carregar o store do localStorage para o store do Redux - " + e);
        return undefined;
    }

}

const configureStore = (initialState: any = {}) => {

    // habilita a ferramenta redux debug no browser
    const composeEnhancers = (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

    const store = createStore(
        rootReducer,
        loadFromLocalStore(),
        composeEnhancers(
            applyMiddleware(thunk)
        )
    );

    store.subscribe(() => saveToLocalStore(store.getState()));
    return store;

}

export const reduxStore = configureStore();